<template>
  <div>
    <small class="red--text">
      現在、ジオターゲティングのみシミュレーションに対応しています。
    </small>
    <v-data-table
      :headers="headers"
      :items="menuList"
      :loading="loading"
      hide-actions
    >
      <template v-slot:items="props" style="width:100%;">
        <tr
          v-show="!editMode || props.item.id === value"
          :class="{ menuRowHover: isHovering(props.item.id) }"
          @click="onClick(props.item.id)"
          @mouseenter="setHover(props.item.id)"
          @mouseleave="setHover(null)"
          class="menuRow"
        >
          <td v-show="!editMode" rowspan="2" class="text-xs-center">
            <v-radio-group
              :value="value"
              name="menuIdSelecter"
              class="pt-1"
              hide-details
            >
              <v-radio
                :key="props.item.id"
                :value="props.item.id"
                @click.stop="onClick(props.item.id)"
                class="ml-4"
              />
            </v-radio-group>
          </td>
          <td>{{ props.item.name }}</td>
          <td style="width:160px;">
            <AppUnitType :value="props.item.unitType" />
            <AppUnitTypeToolTip :unitType="props.item.unitType" />
          </td>
          <td class="text-xs-left">
            <AppCurrency
              :value="props.item.grossPrice"
              currency="JPY"
              actual-number
            />
          </td>
        </tr>
        <tr
          v-show="!editMode || props.item.id === value"
          :class="{ menuRowHover: isHovering(props.item.id) }"
          @click="onClick(props.item.id)"
          @mouseenter="setHover(props.item.id)"
          @mouseleave="setHover(null)"
          class="menuRowDescription"
        >
          <td colspan="5">
            <span class="description">{{ props.item.description }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'PageMenu',
  props: {
    value: {
      type: Number,
      default: null,
    },
    menuList: {
      type: Array,
      default: () => [],
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    clickMenuFunc: {
      type: Function,
      default: () => {},
    },
    loading: Boolean,
  },
  data() {
    return {
      hover: null,
    }
  },
  computed: {
    headers() {
      return this.editMode
        ? [
            { text: 'メニュー名', value: 'name' },
            { text: '課金形態', value: 'unitType', width: '20px' },
            { text: '配信単価', value: 'grossPrice', align: 'left' },
          ]
        : [
            { text: '', value: 'radio', sortable: false },
            { text: 'メニュー名', value: 'name' },
            { text: '課金形態', value: 'unitType', width: '20px' },
            { text: '配信単価', value: 'grossPrice', align: 'left' },
          ]
    },
  },
  methods: {
    setHover(id) {
      this.hover = id
    },
    isHovering(id) {
      return this.hover === id
    },
    async onClick(menuId) {
      if (!this.editMode) {
        if (!this.clickMenuFunc() || (await this.clickMenuFunc(menuId))) {
          this.$emit('input', menuId)
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.v-input__control {
  width: 100%;
}

.menuRow {
  cursor: pointer;
}

.menuRowDescription {
  cursor: pointer;
}

.menuRowHover {
  background-color: #eee;
}

.description {
  opacity: 0.5;
}
</style>
